<template>
	<section class="text">
		<div class="copy" v-html="copy"></div>
		<div class="images">
			<img v-for="(image, i) in images" :key="`img_${i}`" :src="image.url" />
		</div>
		<ModuleGallery class="mobile_gallery" v-if="images" :images="images" />
	</section>
</template>

<script>
export default {
	props: {
		copy: String,
		images: [Boolean, Array],
	},
};
</script>

<style lang="scss" scoped>
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}

	25% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
	}

	50% {
		border-radius: 50% 60% 50% 30% / 50% 50% 50% 70%;
	}

	75% {
		border-radius: 100% 50% 50% 50% / 115% 60% 80% 44%;
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}
.text {
	width: 100%;
	@include moduleSpacing;
	display: flex;
	// padding-top: 50px;
	align-items: flex-start;

	@include mq($to: m) {
		flex-wrap: wrap;
	}

	.copy {
		width: 100%;
		@include fontCopy;
		@include textFormat;

		@include mq($from: m) {
			@include gridColumn(m, 12, 1, false, false);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 12, 2, false, false);
		}
	}

	.mobile_gallery {
		width: 100%;

		&::v-deep .images {
			margin-top: 30px !important;
		}
		@include mq($from: m) {
			display: none;
		}
	}

	.images {
		display: none;
		position: sticky;

		@include mq($from: m) {
			display: block;
			top: 140px;
			@include gridColumn(m, 10, 1, false, true);
		}

		@include mq($from: l) {
			top: 180px;
		}

		@include mq($from: xl) {
			display: block;
			top: 220px;
			@include gridColumn(xl, 9, 1, false, true);
		}

		img {
			display: block;
			max-width: 100%;
			border-radius: 70% 60% 50% 100% / 80% 60% 80% 70%;
			animation: border1 8s infinite linear;
			animation-delay: -6s;

			&:nth-child(2) {
				border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
				margin-top: -10%;
				animation: border1 8s infinite linear;
				animation-delay: -3s;
			}

			&:nth-child(3) {
				border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
				margin-top: -10%;
				animation: border1 8s infinite linear;
			}
		}
	}
}
</style>
